import React from "react";
import { Upload, Dot, FileText, Check, Download, Trash2 } from "lucide-react";
import { Button } from "../ui/button";

export const FileUpload = ({
  fileName,
  heading,
  subheading = null,
  isUpload = false,
}) => {
  return (
    <div className='w-100 w-md-50 flex-basis-1/2 rounded-md text-center cursor-pointer m-2'>
      <div className='flex flex-row gap-2'>
        <span className='bg-neutral-4 p-2 rounded items-center flex'>
          <FileText className='w-5 h-5' />
        </span>
        <div className='flex flex-col text-left'>
          <span>{heading}</span>
          <span className='text-[12px]'>{subheading}</span>
        </div>
        <Button
          variant='primaryOutline'
          className='ml-auto flex items-center gap-2 text-neutral-12'
        >
          <span>Upload</span>

          {isUpload && <Upload className='w-5 h-5 text-neutral-12' />}
        </Button>
      </div>
    </div>
  );
};

export const DotSeprated = ({ left, right }) => {
  return (
    <div className='text-xs text-gray-600 flex flex-row'>
      {left}
      <Dot className='w-[15px] h-[15px]' />
      {right}
    </div>
  );
};

export const DocInfo = ({
  title,
  documents,
  handleDownload = () => {
    console.log("download");
  },
  handleDelete = () => {
    console.log("delete");
  }
}) => {
  return (
    <div className='space-y-3'>
      {title && (
        <div className='font-semibold text-sm text-neutral-13'>{title}</div>
      )}
      {documents &&
        documents.map((item, index) => {
          const { date, time, filename } = item;
          return (
            <div key={index} className='rounded bg-white'>
              <div className='flex items-center mb-2'>
                <div className='bg-system-positive-1 rounded-lg mr-2 p-3'>
                  <Check className='w-4 h-4 text-system-positive-2' />
                </div>
                <div className='flex flex-col'>
                  <div className='font-medium text-xs text-neutral-13 mb-1'>
                    {filename}
                  </div>
                  <DotSeprated left={date} right={time} />
                </div>
                <div className='flex gap-2 flex-grow justify-end'>
                  <Download
                    className='w-4 h-4 cursor-pointer text-secondary-2'
                    onClick={() => {handleDownload(item)}}
                  />
                  <Trash2
                    className='w-4 h-4 cursor-pointer text-system-negative-2'
                    onClick={() => {handleDelete(item)}}
                  />
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};
